var map = {
	"./layaair-logo-black-en.png": 6455,
	"./layaair-logo-black-en_副本.png": 6075,
	"./layaair-logo-black-zh.png": 3146,
	"./layaair-logo-en.png": 7813,
	"./layaair-logo-en_副本.png": 2908,
	"./layaair-logo-zh.png": 1215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;